import { PureComponent } from "react";

import { ErrorBoundaryFallback } from "./error-boundary-fallback";
import type { IErrorBoundaryErrorInfo } from "./error-boundary.models";

interface IErrorBoundaryComponent {
  children: React.ReactNode;
}

interface IErrorBoundaryComponentState {
  error: Error | null;
  errorInfo: IErrorBoundaryErrorInfo | null;
}

export class ErrorBoundary extends PureComponent<
  IErrorBoundaryComponent,
  IErrorBoundaryComponentState
> {
  readonly state: IErrorBoundaryComponentState = {
    error: null,
    errorInfo: null,
  };

  static getDerivedStateFromError(
    error: Error,
  ): Partial<IErrorBoundaryComponentState> {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: IErrorBoundaryErrorInfo): void {
    console.error(`ERROR!- ${error.message} `, error, errorInfo);

    this.setState({ errorInfo });
  }

  render(): React.ReactNode {
    const { error, errorInfo } = this.state;

    if (error) {
      return <ErrorBoundaryFallback error={error} errorInfo={errorInfo} />;
    }

    return this.props.children;
  }
}
